var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.taskableId && _vm.hasTasks),expression:"taskableId && hasTasks"}],staticClass:"task-card-section"},[_c('task-list',{attrs:{"taskable-type":_vm.taskableType,"taskable-id":_vm.taskableId}}),_c('v-divider',{staticClass:"mt-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }